import { EventBus } from "mvc-kit";
//#region src/modules/AuthWrapper2/events/AuthEvents.ts
var AuthEventBus = class extends EventBus {};
//#endregion
export { AuthEventBus };

//# sourceMappingURL=AuthEvents.js.map